import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const aiFirstCreateRoute: InvariantJiraRoute = {
	name: 'ai-first-create-embed',
	path: '/jira/ai-first-create/embed',
	exact: true,
	query: ['conversationChannelId', 'projectIdOrKey'],
};
